<template>
  <div>
    <p class="text-muted" v-if="(!standards || standards.length === 0) && !loadingStandards"><i>No applicable standards</i></p>
    <span v-if="loadingStandards" class="text-muted"><i class="fa fa-circle-o-notch fa-spin fa-fw"/> Loading Standards...</span>
    <A11yDropdown
      :dropdown-props="{
        ref:'standards-dropdown',
        class: 'browse-standards-dropdown list-unstyled',
        'aria-labelledby': standardSelectorLabelId,
        dropup: true
      }"
      :button-props="{
        class: 'btn btn-default dropdown-toggle ellipsis',
        'data-role': 'trigger',
        'aria-label': selectedStandard ? `Standard: ${selectedStandard}` : 'Choose a standard'
      }"
      :dom-attributes="{
        role: 'listbox',
        'aria-label': selectedStandard ? `Standard: ${selectedStandard}` : 'Choose a standard'
      }"
    >
      <template slot="button-contents">
        {{ buttonText }} <i class="fa fa-caret-up"/>
      </template>
      <template slot="dropdown-items">
        <li>
          <a @click="setStandard({})" class="standard-option">Don't filter by standard</a>
        </li>
        <li
          ref="standard.standard_long_ref"
          v-for="(standard, i) in standards"
          :key="standard.standard_long_ref">
          <a
            @click="setStandard(standard)"
            :id="`standard-option-${i}`"
            class="standard-option">
            <h6>{{ standard.standard_short_ref }}</h6>
            <p class="ellipsis standard-text" v-html="standard.standard_text"/>
          </a>
          <popover
            :auto-placement="false"
            trigger="hover-focus"
            :target="`#standard-option-${i}`"
            placement="right"
            :title="standard.standard_short_ref">
            <template slot="popover">
              <div v-html="standard.standard_text" />
            </template>
          </popover>
        </li>
      </template>
    </A11yDropdown>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import PopoverMixin from '@/mixins/PopoverMixin'
import RedundantRouteMixin from '@/components/RedundantRouteMixin.js'
import A11yDropdown from '@/components/A11yDropdown'

export default {
  name: 'BrowseStandardsSelector',
  components: { A11yDropdown },
  data() {
    return {
      buttonText: 'Filter by Standard',
    }
  },
  mixins: [RedundantRouteMixin, PopoverMixin],
  computed: {
    ...mapGetters({
      loadingStandards: 'browse/loadingStandards'
    }),
    selectedStandard: {
      get() {
        return this.query.standard || ''
      },
      set(value) {
        let newQuery = Object.assign({}, this.query)
        if (!value) {
          this.$sendEvent('Unselected Browse Goals Standard', {
            browse_goals_unselected_standard: newQuery.standard
          })

          delete newQuery.standard
        } else {
          newQuery.standard = value

          this.$sendEvent('Selected Browse Goals Standard', {
            browse_goals_selected_standard: value
          })
        }
        this.rerouteIfRouteChanged(this.$route, {
          query: newQuery,
          name: 'BrowseGoalsPage'
        })
      }
    }
  },
  methods: {
    setStandard(standard) {
      this.selectedStandard = standard.standard_long_ref
      if (standard.standard_short_ref) {
        this.buttonText = standard.standard_short_ref
      } else {
        this.buttonText = 'Filter by standard'
      }
    }
  },
  props: {
    standards: {
      type: Array,
      default() {
        return []
      }
    },
    query: {
      type: Object,
      default() {
        return {}
      }
    },
    standardSelectorLabelId: {
      type: String,
      required: true,
    }
  },
  watch: {
    query(to, from) {
      if (!to.standard) {
        this.buttonText = 'Filter by Standard'
      }
    }
  }
}
</script>

<style lang="less">
@import '~@/variables.less';
.browse-standards-dropdown {
  width: 100%;
  .btn.dropdown-toggle {
    width: 100%;
    text-align: left;
    padding-right: 20px;
    position: relative;

    .fa-caret-up {
      position: absolute;
      top: 9px;
      right: 8px;
    }
  }
  .dropdown-menu {
    max-width: ~'calc(100% + 10px)';
    max-height: 400px;
    overflow-y: scroll;

    .standard-option {
      display: block;
      padding: 5px 20px;
      max-width: 300px;
      border-bottom: 2px solid @gray-lighter;
      text-decoration: none;
      color: @gray-dark;
      &:hover {
        background-color: @blue;
        color: white;
        cursor: pointer;
      }
      .standard-text {
        font-size: 12px;
      }
    }
  }
}
</style>
